<div class="mai-nap">

  <div class="mn-head">
    <h1 class="stk-page-title">Mai nap</h1>
    <div class="stk-page-sub">{{ dashDate }} — itt van minden, amivel ma foglalkozni kell.</div>
  </div>

  <!-- KPI kártyák -->
  <div class="mn-kpis">
    <div class="mn-kpi" *ngFor="let k of kpis; trackBy: trackByIndex" (click)="openKpi(k)">
      <div class="mn-kpi__label">{{ k.label }}</div>
      <div class="mn-kpi__value" [ngClass]="'mn-kpi__value--' + k.tone">{{ k.value }}</div>
      <div class="mn-kpi__sub">{{ k.sub }}</div>
    </div>
  </div>

  <div class="mn-grid">

    <!-- Ma feladandó rendelések -->
    <div class="mn-ship">
      <div class="mn-ship__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="12" height="9" rx="1.5"></rect><path d="M14 10 h4 l3 3 v3 h-7"></path><circle cx="7" cy="18.5" r="1.7"></circle><circle cx="17" cy="18.5" r="1.7"></circle></svg>
        <h3 class="mn-ship__title">Ma feladandó rendelések</h3>
        <button type="button" class="mn-link" (click)="goOrders()">Összes rendelés ›</button>
      </div>

      <div class="mn-ship__row" *ngFor="let o of shipRows; trackBy: trackByShip" (click)="openOrder(o.orderId)">
        <div class="mn-ship__main">
          <div class="mn-ship__name-row">
            <span class="mn-ship__name">{{ o.name }}</span>
            <span class="mn-ship__id">{{ o.idLabel }}</span>
            <span class="mn-ship__warn" *ngIf="o.hasStockIssue" title="Készlethiány érinti a rendelést">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#A14D4D" stroke-width="2.2" stroke-linecap="round"><path d="M12 3 L22 20 H2 Z" stroke-linejoin="round"></path><line x1="12" y1="9.5" x2="12" y2="14"></line><circle cx="12" cy="17" r="0.4" fill="#A14D4D"></circle></svg>
            </span>
          </div>
          <div class="mn-ship__place">{{ o.place }}</div>
        </div>
        <span class="mn-ship__chip" [ngClass]="o.late ? 'mn-ship__chip--red' : 'mn-ship__chip--yellow'">{{ o.chipLabel }}</span>
        <button type="button" class="mn-ship__btn" (click)="$event.stopPropagation(); openOrder(o.orderId)">Csomagolás</button>
      </div>

      <div class="mn-ship__empty" *ngIf="ordersLoaded && shipRows.length === 0">Ma nincs feladandó rendelés.</div>

      <button type="button" class="mn-ship__more" *ngIf="shipMore" (click)="goOrders()">{{ shipMore }} ›</button>
    </div>

    <!-- Jobb oszlop -->
    <div class="mn-side">

      <!-- Sürgős gyártás -->
      <div class="mn-card">
        <div class="mn-card__head">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 9 V4 h10 v5"></path><rect x="4" y="9" width="16" height="8" rx="2"></rect><path d="M7 14 h10 v6 H7 Z"></path></svg>
          <h3 class="mn-card__title">Sürgős gyártás</h3>
          <button type="button" class="mn-link mn-link--sm" (click)="goProduction()">Gyártás ›</button>
        </div>
        <div class="mn-dots" *ngIf="mfgRows.length > 0">
          <div class="mn-dot-row" *ngFor="let t of mfgRows; trackBy: trackByIndex">
            <span class="mn-dot" [class.mn-dot--red]="t.red"></span>
            <div class="mn-dot-row__main">
              <div class="mn-dot-row__name">{{ t.name }}</div>
              <div class="mn-dot-row__sub">{{ t.sub }}</div>
            </div>
            <span class="mn-dot-row__need">{{ t.need }}</span>
          </div>
        </div>
        <div class="mn-card__empty" *ngIf="mfgLoaded && mfgRows.length === 0">Nincs nyomtatási feladat.</div>
        <div class="mn-card__more" *ngIf="mfgMore">{{ mfgMore }}</div>
      </div>

      <!-- Készlet riasztások -->
      <div class="mn-card">
        <div class="mn-card__head">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 L22 20 H2 Z"></path><line x1="12" y1="9.5" x2="12" y2="14"></line><circle cx="12" cy="17" r="0.4" fill="#21252B"></circle></svg>
          <h3 class="mn-card__title">Készlet riasztások</h3>
          <button type="button" class="mn-link mn-link--sm" (click)="goComponents()">Komponensek ›</button>
        </div>
        <div class="mn-dots" *ngIf="lowRows.length > 0">
          <div class="mn-dot-row" *ngFor="let c of lowRows; trackBy: trackByIndex">
            <span class="mn-dot" [class.mn-dot--red]="c.red"></span>
            <div class="mn-dot-row__main">
              <div class="mn-dot-row__name">{{ c.name }}</div>
              <div class="mn-dot-row__sub">{{ c.sub }}</div>
            </div>
          </div>
        </div>
        <div class="mn-card__empty" *ngIf="lowLoaded && lowRows.length === 0">Minden komponens minimum felett.</div>
      </div>

      <!-- Számlázás -->
      <div class="mn-card">
        <div class="mn-card__head">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round"><rect x="5" y="3" width="14" height="18" rx="2"></rect><line x1="9" y1="8" x2="15" y2="8"></line><line x1="9" y1="12" x2="15" y2="12"></line><line x1="9" y1="16" x2="13" y2="16"></line></svg>
          <h3 class="mn-card__title">Számlázás</h3>
          <button type="button" class="mn-link mn-link--sm" (click)="goBilling()">Számlázás ›</button>
        </div>
        <span class="mn-inv-chip" [ngClass]="invDanger ? 'mn-inv-chip--red' : 'mn-inv-chip--green'">{{ invLabel }}</span>
      </div>

      <!-- Munkaidő — ma -->
      <div class="mn-card">
        <div class="mn-card__head">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12,7 12,12 15.5,14"></polyline></svg>
          <h3 class="mn-card__title">Munkaidő — ma</h3>
          <button type="button" class="mn-link mn-link--sm" (click)="goWorktime()">Naptár ›</button>
        </div>

        <button type="button" class="mn-wt-start" *ngIf="wtState === 'none'" [disabled]="wtSaving" (click)="startWork()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><polygon points="7,4 20,12 7,20"></polygon></svg>
          Megjöttem — munkaidő indítása
        </button>

        <ng-container *ngIf="wtState === 'progress'">
          <div class="mn-wt-live">
            <span class="mn-wt-live__dot"></span>
            <span class="mn-wt-live__label">{{ wtStartedLabel }}</span>
          </div>
          <button type="button" class="mn-wt-stop" [disabled]="wtSaving" (click)="stopWork()">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><rect x="5" y="5" width="14" height="14" rx="2"></rect></svg>
            Elmentem — munkaidő zárása
          </button>
        </ng-container>

        <div class="mn-wt-done" *ngIf="wtState === 'done'">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7.5"></polyline></svg>
          Mai nap lezárva: {{ wtDoneLabel }}
        </div>

        <div class="mn-wt-off" *ngIf="wtState === 'off'">{{ wtOffLabel }}</div>
      </div>

      <!-- Support — sürgős -->
      <div class="mn-card">
        <div class="mn-card__head">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><circle cx="12" cy="12" r="3.4"></circle><line x1="6" y1="6" x2="9.5" y2="9.5"></line><line x1="18" y1="6" x2="14.5" y2="9.5"></line><line x1="6" y1="18" x2="9.5" y2="14.5"></line><line x1="18" y1="18" x2="14.5" y2="14.5"></line></svg>
          <h3 class="mn-card__title">Support — sürgős</h3>
          <button type="button" class="mn-link mn-link--sm" (click)="goSupport()">Support ›</button>
        </div>
        <div class="mn-sup" *ngIf="supRows.length > 0">
          <div class="mn-sup__row" *ngFor="let t of supRows; trackBy: trackBySup" (click)="openSupportTicket(t)">
            <span class="mn-sup__prio" [style.background]="t.prioColor">{{ t.prioLabel }}</span>
            <div class="mn-sup__main">
              <div class="mn-sup__title">{{ t.title }}</div>
              <div class="mn-sup__status">{{ t.statusLabel }}</div>
            </div>
            <span class="mn-sup__avatar" [style.background]="t.avatarColor" [title]="t.avatarTitle"
                  [appUserAvatar]="t.avatarTitle">{{ t.avatarInitial }}</span>
          </div>
        </div>
        <div class="mn-card__empty" *ngIf="supLoaded && supRows.length === 0">Nincs nyitott support task.</div>
        <div class="mn-card__more" *ngIf="supMore">{{ supMore }}</div>
      </div>

    </div>
  </div>

</div>
